export default function  StarRating ({ rating, size = "sm" })  {
  const sz = size === "sm" ? "text-xs" : "text-sm";
  return (
    <span className={`${sz} text-amber-400`}>
      {"★".repeat(Math.floor(rating))}{"☆".repeat(5 - Math.floor(rating))}
    </span>
  );
};
